import { render, staticRenderFns } from "./CreatorCosts.vue?vue&type=template&id=96480e46&"
import script from "./CreatorCosts.vue?vue&type=script&lang=ts&"
export * from "./CreatorCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports